import { SET_TRUCKS } from '../actionTypes'

const initialState = []


export default (state=initialState,  action) => {
    switch(action.type) {
    case SET_TRUCKS:
      return action.trucks
    default:
        return state
    }
    
}